import { DeviceStatusTypes, DeviceTypes } from '../enums';

export interface Device {
  DeviceId: number;
  Name: string;
  DeviceType: DeviceTypes;
  StatusType: DeviceStatusTypes;
  MerchantId?: number;
  LocationId?: number;
  MerchantName?: string;
  LocationName?: string;
  ConnectionId?: string;
  SerialNumber?: string;
}
